<br />
<div class="container">
  <div class="row" style="padding-top: 10%">
    <div class="col-sm"></div>
    <div class="col-sm-7">
      <div class="card">
        <div class="card-header">
          <h1>Empresas</h1>
          <button
            style="float: right; padding: 10px; margin-right: 10px"
            class="btn btn-primary btn-sm"
          >
            <i class="fas fa-plus"></i>
          </button>
          <button
            style="float: right; padding: 10px; margin-right: 10px"
            class="btn btn-danger btn-sm"
            (click)="logOut()"
          >
            <i class="fas fa-power-off"></i>
          </button>
          <input
            id="myInput"
            type="text"
            placeholder="Buscar"
            (keyup)="searchData()"
          />
        </div>
        <div class="card-body">
          <table
            id="myTable"
            class="table table-sm table-responsive-sm table-bordered"
          >
            <thead class="thead-dark">
              <tr>
                <th>Empresa</th>
                <th>NIT</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let empresa of empresas">
                <td style="width: 30%">{{ empresa.nombreComercial }}</td>
                <td style="width: 30%">{{ empresa.nit }}</td>
                <td style="width: 1%">
                  <button
                    class="btn btn-small btn-secondary"
                    (click)="getIdEmpresas(empresa.id)"
                  >
                    <i class="fas fa-sign-in-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-sm"></div>
  </div>
</div>
